import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class Specilizing extends Component {
    constructor(props) {
        super(props);
        this.state= {
            card : [
                {
                    id: 1,
                    classimg: 'featured-post mg-b43',
                    srcimg: './images/section/20.png',
                    altimg: 'images',
                    title: 'Producción y Postproducción Audiovisual',
                    text01: "He trabajado con marcas como Compensar, ICBF, casa Luker fundación, Gobernación de Santander, Ministerio de comercio industria y turismo, Davivienda, Fundación Red papaz, CNN, ProColombia, entre otros. Ganador de un tercer puesto en una competencia internacional de filminutos.",
                    text02: "10 años de experiencia."
                },
                {
                    id: 2,
                    classimg: 'featured-post mg-b42',
                    srcimg: './images/section/22.png',
                    altimg: 'images',
                    title: 'Creativo',
                    text01: "Como director creativo de la agencia publicitaria que constituí, logramos ganar campañas políticas de ciudades capitales y departamentales en Colombia, usando creatividad efectiva, medios digitales, campañas ATL y BTL. ",
                    text02: "4 años de experiencia."
                },
                {
                    id: 3,
                    classimg: 'featured-post mg-b40',
                    srcimg: './images/section/21.png',
                    altimg: 'images',
                    title: 'Desarrollador Web y Apps',
                    text01: "Usando el stack tecnológico MERN he creado una plataforma y 2 aplicaciones móviles, logrando explorar con usuarios reales sus problemas y posibles soluciones.",
                    text02: "2 años de experiencia."
                }
            ]
        }
    }
    
    render() {
        return (           
            <div className="tf-modal-content">    
                <section className="experienced s3 banner-section" id="services">
                    <div className="container">
                        <div className="background-inner bg-s1">
                            <div className="flat-title animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">
                            <h2 className="title-section color-d19 mg-b44 text-center">Me especializo en:</h2>
                            </div>
                            <div className="row animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                                {
                                    this.state.card.map(data => (
                                        <div className="col-lg-4" key={data.id}>
                                            <div className="iconbox-s2">
                                                <div className={data.classimg}><img src={data.srcimg} alt={data.altimg} /></div>
                                                <h3 className="title mg-b21"><Link to="#">{data.title}</Link></h3>
                                                <p>
                                                {data.text01} <br />{data.text02}
                                                </p>
                                            </div>
                                        </div>  
                                    ))
                                }                       
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Specilizing;
